const mode = process.env.NODE_ENV || "development";
const environment = process.env;

export const config = {
    API_URL: environment.API_URL,
    MODE: mode
};